const VERSION = 'v1.1.1';

export default VERSION;



// WEBPACK FOOTER //
// ../gwi-brick/src/config/version.js